import type { WidgetItemType } from '@src/store/dashboardTemp/@types';

export const dashboardWidgets: WidgetItemType[] = [
    {
        id: 0,
        type: 'counter',
        title: 'Кількість записів за сьогодні',
        access: true,
    },
    {
        id: 1,
        type: 'counter',
        title: 'Кількість записів за вчора',
        access: false,
    },
    {
        id: 2,
        type: 'lineChart',
        title: 'Доставка їжі',
        access: true,
        data: [
            {
                name: "Кур'єр 1",
                uv: 4000,
                pv: 2400,
                amt: 2400,
            },
            {
                name: "Кур'єр 2",
                uv: 3000,
                pv: 1398,
                amt: 2210,
            },
            {
                name: "Кур'єр 3",
                uv: 2000,
                pv: 9800,
                amt: 2290,
            },
            {
                name: "Кур'єр 4",
                uv: 2780,
                pv: 3908,
                amt: 2000,
            },
            {
                name: "Кур'єр 5",
                uv: 1890,
                pv: 4800,
                amt: 2181,
            },
        ],
    },
    {
        id: 3,
        type: 'barChart',
        title: 'Доставка їжі',
        access: true,
        data: [
            {
                name: "Кур'єр 1",
                uv: 4000,
                pv: 2400,
                amt: 2400,
            },
            {
                name: "Кур'єр 2",
                uv: 3000,
                pv: 1398,
                amt: 2210,
            },
            {
                name: "Кур'єр 3",
                uv: 2000,
                pv: 9800,
                amt: 2290,
            },
            {
                name: "Кур'єр 4",
                uv: 2780,
                pv: 3908,
                amt: 2000,
            },
            {
                name: "Кур'єр 5",
                uv: 1890,
                pv: 4800,
                amt: 2181,
            },
        ],
    },
    {
        id: 4,
        type: 'text',
        title: 'Доставка їжі',
        access: true,
        data: [
            '<h1>Дашборд Контроль кур’єрів</h1>' +
                '<p>Якийсь текст......</p>'.repeat(30),
        ],
    },
    {
        id: 5,
        type: 'pieChart',
        title: 'Доставка їжі',
        access: true,
        data: [
            {
                name: "Кур'єр 1",
                value: 20,
            },
            {
                name: "Кур'єр 2",
                value: 21,
            },
            {
                name: "Кур'єр 3",
                value: 59,
            },
        ],
    },
    {
        id: 6,
        type: 'table',
        title: 'Доставка їжі',
        access: true,
        data: [
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 1",
                on_time: 'Вчасно',
                key: '1',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 2",
                on_time: 'Невчасно',
                key: '2',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 3",
                on_time: 'Вчасно',
                key: '3',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 4",
                on_time: 'Невчасно',
                key: '4',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 5",
                on_time: 'Вчасно',
                key: '5',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 6",
                on_time: 'Невчасно',
                key: '6',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 1",
                on_time: 'Вчасно',
                key: '1',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 2",
                on_time: 'Невчасно',
                key: '2',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 3",
                on_time: 'Вчасно',
                key: '3',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 4",
                on_time: 'Невчасно',
                key: '4',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 5",
                on_time: 'Вчасно',
                key: '5',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 6",
                on_time: 'Невчасно',
                key: '6',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 1",
                on_time: 'Вчасно',
                key: '1',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 2",
                on_time: 'Невчасно',
                key: '2',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 3",
                on_time: 'Вчасно',
                key: '3',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 4",
                on_time: 'Невчасно',
                key: '4',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 5",
                on_time: 'Вчасно',
                key: '5',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 6",
                on_time: 'Невчасно',
                key: '6',
            },
        ],
    },
    {
        id: 7,
        type: 'counter',
        title: 'Кількість записів за сьогодні',
        access: true,
    },
    {
        id: 8,
        type: 'lineChart',
        title: 'Надходження оплат',
        access: true,
        data: [
            {
                name: "Кур'єр 1",
                uv: 4000,
                pv: 2400,
                amt: 2400,
            },
            {
                name: "Кур'єр 2",
                uv: 3000,
                pv: 1398,
                amt: 2210,
            },
            {
                name: "Кур'єр 3",
                uv: 2000,
                pv: 9800,
                amt: 2290,
            },
            {
                name: "Кур'єр 4",
                uv: 2780,
                pv: 3908,
                amt: 2000,
            },
            {
                name: "Кур'єр 5",
                uv: 1890,
                pv: 4800,
                amt: 2181,
            },
        ],
    },
    {
        id: 9,
        type: 'table',
        title: 'Доставка їжі',
        access: true,
        data: [
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 1",
                on_time: 'Вчасно',
                key: '1',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 2",
                on_time: 'Невчасно',
                key: '2',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 3",
                on_time: 'Вчасно',
                key: '3',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 4",
                on_time: 'Невчасно',
                key: '4',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 5",
                on_time: 'Вчасно',
                key: '5',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 6",
                on_time: 'Невчасно',
                key: '6',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 1",
                on_time: 'Вчасно',
                key: '1',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 2",
                on_time: 'Невчасно',
                key: '2',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 3",
                on_time: 'Вчасно',
                key: '3',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 4",
                on_time: 'Невчасно',
                key: '4',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 5",
                on_time: 'Вчасно',
                key: '5',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 6",
                on_time: 'Невчасно',
                key: '6',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 1",
                on_time: 'Вчасно',
                key: '1',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 2",
                on_time: 'Невчасно',
                key: '2',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 3",
                on_time: 'Вчасно',
                key: '3',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 4",
                on_time: 'Невчасно',
                key: '4',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 5",
                on_time: 'Вчасно',
                key: '5',
            },
            {
                time: '11.03.2022 12:45',
                courier: "Кур'єр 6",
                on_time: 'Невчасно',
                key: '6',
            },
        ],
    },
    {
        id: 10,
        type: 'barChart',
        title: 'Замовлення',
        access: true,
        data: [
            {
                name: "Кур'єр 1",
                uv: 4000,
                pv: 2400,
                amt: 2400,
            },
            {
                name: "Кур'єр 2",
                uv: 3000,
                pv: 1398,
                amt: 2210,
            },
            {
                name: "Кур'єр 3",
                uv: 2000,
                pv: 9800,
                amt: 2290,
            },
            {
                name: "Кур'єр 4",
                uv: 2780,
                pv: 3908,
                amt: 2000,
            },
            {
                name: "Кур'єр 5",
                uv: 1890,
                pv: 4800,
                amt: 2181,
            },
        ],
    },
];
